export interface PayoutsListingRequest {
  businessId: string;
  from_date: string;
  to_date: string;

  requestType: PayoutsListingRequestType[];
}

export enum PayoutsListingRequestType {
  DAY_WISE_PAYOUT_SUMMARY,
  PAYOUTS_LISTING,
  CURRENT_PAYOUTS_PREFERENCES,
}
